import React, {useEffect, useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectProducts, fetchProducts } from '../redux/productsSlice';
import ProductCard from './ProductCard';
import './Products.css';

const Bas = () => {
  const products = useSelector(selectProducts);
  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);
  const basProducts = products.filter(product => product.category === 'Bas');

  const productsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const containers = productsRef.current.querySelectorAll('.product-card');
    containers.forEach(container => observer.observe(container));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="products" ref={productsRef}>
      {basProducts.map(product => (
        <ProductCard key={product._id} product={product} />
      ))}
    </div>
  );
};

export default Bas;
